export interface PicqerWarehouse {
  idwarehouse: number;
  name: string;
  accept_orders: boolean;
  counts_for_general_stock: boolean;
  priority: number;
  active: boolean;
}

export interface PicqerLocation {
  idlocation: number;
  idwarehouse: number;
  parent_idlocation?: number | null;
  name: string;
  type: string;
  is_bulk_location?: boolean;
  active?: boolean;
}

export interface PicqerLocationStockHistoryEntry {
  idproduct_location_stock_history: number;
  idproduct: number;
  idlocation: number;
  contra_idlocation: number | null;
  iduser: number | null;
  old_stock: number;
  stock_change: number;
  new_stock: number;
  change_type: string;
  changed_at: string;
}

export type MetricMode = 'avg-month-occupation' | 'any-time-in-month' | 'month-end-snapshot';
export type ChartYMode = 'percent' | 'absolute';

export interface MonthlyWarehouseMetric {
  month: string;
  warehouseId: number;
  warehouseName: string;
  totalLocations: number;
  /** Locations with any occupation in the month (fraction > 0) */
  usedLocations: number;
  /** Warehouse-level used % (avg occupation fraction or month-end snapshot) */
  usedPercent: number;
  daysInMonth: number;
  /** Sum of occupied days across all locations (fraction × daysInMonth per location) */
  occupiedLocationDays: number;
}

export interface WarehouseSummaryRow {
  warehouseId: number;
  warehouseName: string;
  /** Real (leaf) locations in warehouse — parent/grouping nodes excluded */
  totalLocationsAll: number;
  /** Leaf locations included in chart (history loaded) */
  totalLocations: number;
  maxLocations: number;
  maxLocationsMonth: string;
  peakPercent: number;
  peakMonth: string;
}

export interface PicqerAnalyseCache {
  version: 1;
  sincedate: string;
  untildate: string;
  locationsByWarehouse: Record<number, PicqerLocation[]>;
  historyByLocation: Record<number, PicqerLocationStockHistoryEntry[]>;
  preRangeStockByLocation: Record<number, number>;
}

export const ANALYSE_SINCE_DATE = '2025-01-01 00:00:00';
export const ANALYSE_UNTIL_DATE = '2026-06-01 23:59:59';

/** Per API key — Picqer allows 500/min per key */
export const PICQER_MAX_REQUESTS_PER_MINUTE_PER_KEY = 400;
/** Max numbered pool keys PICQER_GENERAL_API_KEY_1 … _5 (plus legacy PICQER_GENERAL_API_KEY) */
export const PICQER_API_KEY_POOL_MAX = 6;
/** Workers per key slot (concurrency = poolSize × this, set after pool init) */
export const HISTORY_WORKERS_PER_KEY = 2;
/** Parallel warehouse location-list fetches */
export const LOCATIONS_FETCH_CONCURRENCY = 3;
